import { Colors } from '@oy/uicore';
import { Button, Padder, Spacer, Text } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import classNames from 'classnames';
import { Tooltip } from 'react-tooltip';
import { UpgradeAccountModal } from 'src/components/UpgradeAccountModal';
import { useTranslate } from 'src/hooks';
import styles from '../Sidebar.module.css';
import { useBalanceTooltipImpl } from './useBalanceTooltipImpl';

export const BalanceTooltip = ({
  showTooltip,
  setShowTooltip,
  balanceDetails,
}: {
  showTooltip: boolean;
  setShowTooltip: (val: boolean) => void;
  balanceDetails: Array<{ description: string; value: string; label: string }>;
}) => {
  const { getTranslation } = useTranslate();

  const { state, onCloseModalWarning, onClickTopUp, openWithdrawal } =
    useBalanceTooltipImpl();

  const {
    showModalWarning,
    product,
    isViewOnlyChildActive,
    isSubmittingWithdrawal,
  } = state;

  return (
    <>
      <UpgradeAccountModal
        showModal={showModalWarning}
        product={product}
        onClose={onCloseModalWarning}
      />
      <Tooltip
        openOnClick
        isOpen={showTooltip}
        setIsOpen={setShowTooltip}
        anchorSelect="#menuDetailBalance"
        className={styles.balanceTooltip}
        place="right"
        clickable
        render={() => {
          return (
            <div>
              <div className={styles.balanceTooltipHeader}>
                <span onClick={() => setShowTooltip(false)} role="button">
                  <SystemIcon name="close2" color={Colors.BLACK100} />
                </span>
                <Text textStyle={Text.Style.BodyXlSemibold}>
                  {getTranslation('common_detailBalance')}
                </Text>
              </div>
              <hr style={{ margin: 0 }} />
              <div>
                {balanceDetails.map(balanceDetail => (
                  <div
                    className={styles.balanceDetailRow}
                    key={`BalanceDetail_${balanceDetail.label}`}
                  >
                    <Text textStyle={Text.Style.BodyLgRegular}>
                      {balanceDetail.label}
                      <Spacer
                        tag="span"
                        left={Spacer.Size.XS}
                        data-tooltip-id="balance-tooltip-description"
                        data-tooltip-content={balanceDetail.description}
                      >
                        <SystemIcon
                          name="information"
                          size={18}
                          color={Colors.BLACK100}
                        />
                      </Spacer>
                    </Text>
                    <Text textStyle={Text.Style.BodyXlSemibold}>
                      {balanceDetail.value}
                    </Text>
                  </div>
                ))}
                <Tooltip
                  place="right"
                  className={classNames(
                    styles.menuTooltip,
                    styles.balanceDetailTooltip,
                  )}
                  id="balance-tooltip-description"
                />
              </div>
              <Padder all={Padder.Size.M} className={styles.balanceButtonGroup}>
                <Button onClick={onClickTopUp} id="btnTopUp">
                  {getTranslation('common_topUp')}
                </Button>
                {!isViewOnlyChildActive && (
                  <Button
                    buttonType={Button.Type.Outlined}
                    disabled={isSubmittingWithdrawal}
                    onClick={() => {
                      openWithdrawal();
                      setShowTooltip(false);
                    }}
                    id="btnWithdraw"
                  >
                    {isSubmittingWithdrawal
                      ? getTranslation('common_pleaseWait')
                      : getTranslation('common_withdraw')}
                  </Button>
                )}
              </Padder>
            </div>
          );
        }}
      />
    </>
  );
};
